import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Container, Row, Col, Form } from 'react-bootstrap';
import "./CRUDSensors.css";
import { Server_URL } from "../config.js";

function CreateSensor() {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    SNo: '', Size: '', PartNo: '', Ratio: '',
    SensorOD: '', SensorAA: '', SensorThick: '', CoverVA: '',
    ChannelRxTx: '', ControlCard: '',
    FpcLoc: '', PrintPN: '', CustomerPN: '',
    Note: '', DrawYes: ''
  })

  // console.log("get into /CreateSensor()");
  // console.log("get into /CreateSensor() values :", values);

  function handleSubmit(e) {
    // console.log("get into /CreateSensor Submit values :", values);
    e.preventDefault()
    axios
      .post(`${Server_URL}/add_sensor`, values)
      // .post('http://localhost:3022/add_sensor', values)
      // .post('http://localhost:5000/add_sensor', values)
      .then((res) => { navigate(-1); })
      // .then((res) => { navigate('/CRUDSensors'); })
      // .then((res) => { navigate('/'); console.log(res); })
      .catch((err) => console.log(err))

    /*
    axios
      .post('/add_user', values)
      .then((res) => {
        navigate('/')
        console.log(res)
      })
      .catch((err) => console.log(err))
    */
  }

  return (
    <div className='vh-100 vw-100 bg-info-subtle'>
      <Container className='container-fluid'>
        <Row>
          <div className='d-flex justify-content-center'> <h2>Add Sensor</h2> </div>
        </Row>
        <Row>
          <Col className='col-md-6 justify-content-start'>
            <button className='btn btn-success' onClick={() => navigate(-1)}>Back</button>
          </Col>
          <Col className='col-md-6'> </Col>
        </Row>
      </Container>
      <Container className='container-fluid vh-80 vw-100 bg-primary-subtle'>
        <Form onSubmit={handleSubmit}>
          <br />
          <Row>
            <Col className='col-md-2'>
              <label htmlFor='SNo'><b>SNo : </b></label>
              <input type='number' onChange={(e) => setValues({ ...values, SNo: e.target.value })} required />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='Size'>Size : </label>
              <input type='text25' onChange={(e) => setValues({ ...values, Size: e.target.value })} required />
            </Col>
            <Col className='col-md-4'>
              <label htmlFor='PartNo'>PartNo : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, PartNo: e.target.value })} required />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='Ratio'>Ratio : </label>
              <input type='text25' onChange={(e) => setValues({ ...values, Ratio: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-3'>
              <label htmlFor='SensorOD'>SensorOD : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, SensorOD: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='SensorAA'>SensorAA : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, SensorAA: e.target.value })} required />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='SensorThick'>SensorThick : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, SensorThick: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-6'>
              <label htmlFor='ChannelRxTx'>ChannelRxTx : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, ChannelRxTx: e.target.value })} />
            </Col>
            <Col className='col-md-6'>
              <label htmlFor='ControlCard'>ControlCard/IC : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, ControlCard: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-3'>
              <label htmlFor='FpcLoc'>FpcLoc : </label>
              <input type='text25' onChange={(e) => setValues({ ...values, FpcLoc: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='PrintPN'>PrintPN : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, PrintPN: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='CustomerPN'>CustomerPN : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, CustomerPN: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-8'>
              <label htmlFor='Note'>Note : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, Note: e.target.value })} />
            </Col>
          </Row>
          <Row>
            <Col className='col-md-3'>
              <label htmlFor='DrawYes'>DrawYes : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, DrawYes: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row className='row'>
            <Col className='col-md-3 d-flex justify-content-start'>
              <button type='submit' className='btn btn-success'>Save</button>
            </Col>
          </Row>
        </Form>
      </Container>
    </div >
  )
}

export default CreateSensor